import { PropsWithChildren } from "react";
import AdminRoutes from "./AdminRoutes";
import { Link } from "react-router-dom";

interface IAdminLayoutProps {
    selectedId: number;
}

export default function AdminLayout(props: PropsWithChildren<IAdminLayoutProps>) {
    return (
        <div className="card">
            <div className="card-header">
                <h1 className="text-muted">Administrator Dashboard</h1>
            </div>
            <div className="card-body">
                <div className="d-flex align-items-start">
                    <ul className="nav flex-column nav-pills me-3 col-2">
                        {AdminRoutes.filter(r => r.displayInNav).map((route, index) => {
                            let className = 'nav-link';
                            
                            if (route.id === props.selectedId) {
                                className += ' active';
                            }

                            return (
                                <li className="nav-item"
                                    key={index}>
                                    <Link to={route.path} className={className}>{route.title}</Link>
                                </li>
                            )
                        })}
                    </ul>
                    <div className="col-10 pe-3">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}